import axios, { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import { getAppConfigSetting } from '../utils'
import { SENTINEL_API } from './constants'
import queryKeys from '../api/queryKeys'
import { TerminalPositionJournalStates } from '../constants/cashTransferConstants'
import { TransferMechanism, CashDirection } from '@Types'

export interface PositionJournalDetails {
  sourceAccount: string
  destinationAccount: string
  securityId: string
  securityIdType: string
  price: number
  quantity: number
}

export interface PositionJournalTransfer {
  id?: string
  externalId?: string
  method?: TransferMechanism
  direction?: CashDirection
  amount?: number
  initiationTime?: string
  status?: TerminalPositionJournalStates
  positionJournalDetails?: PositionJournalDetails
}

export const buildApiUrl = (accountNumber: string) => {
  const baseUrl = getAppConfigSetting('apiUrl')
  return `${baseUrl}${SENTINEL_API}/transfers/${accountNumber}?type=POSITION_JOURNAL`
}

export default function useGetPositionJournalTransfers(accountNumber: string) {
  const getPositionJournalTransfersUrl = buildApiUrl(accountNumber)
  const getPositionJournalTransfers = async () => {
    const { data } = await axios.get(getPositionJournalTransfersUrl, {
      withCredentials: true
    })
    return data as PositionJournalTransfer[]
  }

  return useQuery<PositionJournalTransfer[], AxiosError>(
    [queryKeys.positionJournalTransfers, accountNumber],
    getPositionJournalTransfers,
    {
      // The query will not execute until the accountNumber exists
      enabled: !!accountNumber
    }
  )
}
